import { render } from "./Question.vue?vue&type=template&id=5742fd24&scoped=true"
import script from "./Question.vue?vue&type=script&lang=js"
export * from "./Question.vue?vue&type=script&lang=js"

import "./Question.vue?vue&type=style&index=0&id=5742fd24&scoped=true&lang=css"

import exportComponent from "/var/www/ca-quiz.staging.mindoza.net/releases/20240705152708/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5742fd24"]])

export default __exports__